<template>
    <div
        class="lamp"
        :class="lampStyle"
    ></div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters('knowledgebase/versions', ['isVersionModified']),
    ...mapGetters('knowledgebase/statuses', ['currentStatus']),

    lampStyle () {
      let style

      switch (this.currentStatus) {
        case 'NOT_BUILT':
          style = 'grey'
          break
        case 'LOADING':
          style = 'grey--blink'
          break
        case 'BUILDING':
          style = 'green--blink'
          break
        case 'READY':
          style = this.isVersionModified ? 'grey' : 'green'
          break
        case 'READY_TO_PUBLISH':
          style = 'ready-to-publish'
          break
        case 'FAILED':
          style = 'red'
          break
        case 'PUBLISHING':
          style = 'blue--blink'
          break
        case 'PUBLISHED':
          style = this.isVersionModified ? 'grey' : 'blue'
          break

        default: break
      }

      return style
    }
  }
}
</script>

<style lang="scss" scoped>
    .lamp {
        display: inline-block;
        width: 8px;
        height: 8px;
        border-radius: 100%;
        margin-right: 8px;

        @keyframes blinking {
            0% { opacity: .2; }
            50% { opacity: 1; }
            100% { opacity: .2; }
        }

        &.grey {
            background-color: $or-grey-dark;

            &--blink {
                background-color: $or-grey-dark;
                animation: blinking 1s infinite;
            }
        }

        &.green {
            background-color: $or-green;

            &--blink {
                background-color: $or-green;
                animation: blinking 1s infinite;
            }
        }

        &.ready-to-publish {
            background-color: $or-green;
        }

        &.blue {
            background-color: $or-blue;

            &--blink {
                background-color: $or-blue;
                animation: blinking 1s infinite;
            }
        }

        &.red {
            background-color: $or-red;
        }
    }
</style>
